module.exports = {
	colors: {
		main: '#5a328b',
		sec: '#d3c20c',
		alt: '#5a328b',
	},

	showFunds: false,
	showBuses: false,
	useBusAssistantGPS: false,
	showHomeworks: true,
	showSchoolDay: true,
	showLanguages: false,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['+963989557708'],
		phones: ['0215432666'],
		address: 'معهد شمس التعليمي - دوار الكرة الأرضية مقابل نادي الضباط',
		data: [],
		email: null,
		facebook: 'https://www.facebook.com/profile.php?id=100088777002121&mibextid=ZbWKwL',
		telegram: null,
		privacy: null,
		details: [
			{
				title: 'معهد شمس',
				content: [
					'معهد شمس التعليمي الرائد في حلب لكافة المراحل.',

					'يمتاز معهدنا بإهتمامه الفائق بطلابه فرداً فرداً وبأساليبه التعليمية المعاصرة و رعايته لمواهب طلابه وتنميتهم و الإضاءة على قدراتهم الدراسيّة و الإبداعيّة.',
					
					'وأمّا عن كادر معهد شمس التعليمي فقد تم انتقائه بعناية فإنّ لكلّ معلّمٍ و معلّمة فيهم بصمة خاصة تزيد شمس بريقاً، فهو الكادر الأول الّذي يتابع الحالة النفسية والمزاجية لطلابه وذلك يكون بتنظيم أوقاتهم و تحديد أولوياتهم.',

					'لمعهد شمس تاريخ عريق مكلّلٌ بالنجاحات والأرقام القياسية فنحن على موعد سنوي ثابت مع طلاب الشهادتين بمجاميعهم الكاملة ومراتبهم الأولى على القطر، ولا تقلّ إنجازات طلابنا في المراحل الانتقالية أهميّة عن الشهادات فهم مميزون في إبداعهم وتطوير أنفسهم و إلمامهم بكل المعارف.',

					'يعمل معهد شمس على التطوّر دائماً و لا تأبه لأي عائقٍ يواجهها أو مشكلة تعترض طريقها وعلى هذا المنوال و هذه الخطى تُكمِل شمس بريقها.'
				],
			},
		],
	},

	pwa: {
		name: 'Shams institute ',
		shortName: 'Shams institute ',
		description: 'Shams institute app - portal version for Shams institute app.',
	},
};
